<template>
	<div class="mt-1">
		<div class="d-flex align-items-center">
			<div class="mr-2">
				<template v-if="characteristic.children.length > 0">
					<a href="#" @click.prevent="showChilds = !showChilds" class="color-black text-decoration-none">
						<Icon icon="caret-up" :rotate="showChilds ? 180 : 90"/>
						{{ characteristic.label }}
					</a>
				</template>
				<template v-else>
					<b-form-checkbox :checked="isChecked" @change="onSelect">{{ characteristic.label }}</b-form-checkbox>
				</template>
			</div>
		</div>
		<div v-if="showChilds" class="pl-4">
			<characteristic-tree-select-item
				v-for="child in characteristic.children"
				:key="child.id"
				:characteristics="characteristics"
				:characteristic="child"
				:parent="characteristic"
				:selected="selected"
				@change="$emit('change', $event)"
			/>
		</div>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon"
import _ from "lodash";
import {getChildIdsToLastLevel} from "@/helper/application/characteristic/Provider";

export default {

	props: {
		characteristic: {
			type: Object,
			required: true,
		},
		characteristics: {
			type: Array,
			required: true,
		},
		parent: {
			type: Object,
			required: false,
		},
		selected: {
			type: Object,
			required: false,
		},
	},

	components: {
		Icon,
	},

	data ()
	{
		const allChildIds = getChildIdsToLastLevel(this.characteristic, this.characteristics);

		return {
			showChilds: this.selected && _.includes(allChildIds, this.selected.id),
		};
	},

	computed: {
		isChecked ()
		{
			return this.selected && this.selected.id === this.characteristic.id;
		},
	},

	methods: {
		onSelect (selected)
		{
			if (!selected)
			{
				this.$emit('change', undefined);
				return;
			}

			this.$emit('change', this.characteristic);
		},
	},
}
</script>